import { render, staticRenderFns } from "./FormConfigMachine.vue?vue&type=template&id=4484dbc1"
import script from "./FormConfigMachine.vue?vue&type=script&lang=ts"
export * from "./FormConfigMachine.vue?vue&type=script&lang=ts"
import style0 from "./FormConfigMachine.vue?vue&type=style&index=0&id=4484dbc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports